import { __awaiter, __generator } from "tslib";
import { networkRequest } from '@tencent/ark-request';
import { ApiError } from '../error/api-error';
import { ApiErrorCode } from '../error/api-error-code';
import { LoggerProxy } from '../logger/logger-proxy';
var createDocumentUrl = '/cgi-bin/online_docs/createdoc_new';
var createType = '11'; // 创建文档的类型？表示离线新建文档;
var createTemplateId = '0'; // 新建空白模板的 id
var createVersion = '2.0.0'; // 新建的版本号
var disableAutoRename = '1'; // 是否禁用自动修改文档标题能力
var defaultDomainId = '300000000'; // 文档默认 domain id
var AbstractPadInfoCreator = /** @class */ (function () {
    function AbstractPadInfoCreator() {
    }
    Object.defineProperty(AbstractPadInfoCreator.prototype, "createPadInfoFromServer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (option, config, storageManager) {
            return __awaiter(this, void 0, void 0, function () {
                var keyframeData, requestBody, response, status, statusText;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            LoggerProxy.info(AbstractPadInfoCreator.tag, '开始发送CGI请求创建文档, option = ', option);
                            return [4 /*yield*/, this.buildCreateRequestKeyframe(option, config, storageManager)];
                        case 1:
                            keyframeData = _a.sent();
                            requestBody = this.buildCreateRequestBody(option, config, keyframeData);
                            LoggerProxy.info(AbstractPadInfoCreator.tag, '开始发送CGI请求创建文档, requestBody = ', requestBody);
                            return [4 /*yield*/, networkRequest.post(createDocumentUrl, requestBody)];
                        case 2:
                            response = _a.sent();
                            LoggerProxy.info(AbstractPadInfoCreator.tag, '开始发送CGI请求创建文档, response = ', response);
                            status = response.status, statusText = response.statusText;
                            if (response.status !== 200) {
                                LoggerProxy.error(AbstractPadInfoCreator.tag, '发送CGI请求创建文档异常, 原因: 状态码 = ${status}');
                                throw new ApiError({
                                    code: ApiErrorCode.CreateDocumentError,
                                    subCode: -20001,
                                    message: "".concat(AbstractPadInfoCreator.tag, " \u53D1\u9001CGI\u8BF7\u6C42\u521B\u5EFA\u6587\u6863\u5F02\u5E38. url = ").concat(createDocumentUrl, ", status = ").concat(status, ", statusText = ").concat(statusText, "."),
                                });
                            }
                            return [2 /*return*/, response.data];
                    }
                });
            });
        }
    });
    Object.defineProperty(AbstractPadInfoCreator.prototype, "buildCreateRequestBody", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (option, config, keyframe) {
            var _a;
            LoggerProxy.info(AbstractPadInfoCreator.tag, '生成创建文档请求 URL, option = ', option);
            var searchParams = new URLSearchParams();
            var _b = this.getDomainIdAndPadId(option.globalPadId), domainId = _b.domainId, padId = _b.padId;
            searchParams.set('create_type', createType);
            searchParams.set('pad_id', padId);
            searchParams.set('domain_id', domainId);
            searchParams.set('templateId', createTemplateId);
            searchParams.set('version', createVersion);
            searchParams.set('folder_id', (_a = option.folderId) !== null && _a !== void 0 ? _a : '/');
            searchParams.set('title', option.title);
            searchParams.set('xsrf', config.requestParams.xsrf);
            searchParams.set('doc_type', option.documentType.toString());
            if (option.isUserChangeTitle) {
                searchParams.set('disable_auto_rename', disableAutoRename);
            }
            searchParams.set('last_browse_ts', "".concat(keyframe.lastModifyTimestamp / 1000));
            searchParams.set('data', keyframe.data);
            if (keyframe.atext) {
                searchParams.set('atext', keyframe.atext);
            }
            if (keyframe.apool) {
                searchParams.set('apool', keyframe.apool);
            }
            return searchParams;
        }
    });
    ;
    /**
     * 解析文档 domain id 和 padId
     * 起源：企微融合后，文档 id 有如下情况
     * 腾讯文档：secretId = xxxxxx, globalPadId = domainId$padId（domainId = 300000000）
     * toB文档：secretId = globalPadId = padId = w3_xxxxxx, domainId = 300000000
     *
     * @protected
     * @param {string} globalPadId
     * @return {*}  {{ domainId: string, padId: string }}
     * @memberof AbstractPadInfoCreator
     */
    Object.defineProperty(AbstractPadInfoCreator.prototype, "getDomainIdAndPadId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (globalPadId) {
            var result = globalPadId.match(/([0-9]+)\$(.*)/);
            if (result) {
                var domainId = result[1], padId = result[2];
                return { domainId: domainId, padId: padId };
            }
            return {
                domainId: defaultDomainId,
                padId: globalPadId,
            };
        }
    });
    Object.defineProperty(AbstractPadInfoCreator, "tag", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'AbstractPadInfoCreator'
    });
    return AbstractPadInfoCreator;
}());
export { AbstractPadInfoCreator };
